import React, { useState, useEffect, Fragment } from "react";
import Typography from '@mui/material/Typography';
import { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import Skeleton from '@mui/material/Skeleton';
import Link from 'next/link'
import {nanoid} from 'nanoid'
import Image from "next/image";
import darkTheme  from '../../src/theme';

const sliderContainer = {
    marginTop: darkTheme.spacing(2),
    marginBottom: darkTheme.spacing(3),
    [darkTheme.breakpoints.down("md")]: {
        marginTop: darkTheme.spacing(6),
    },
};

const slider = {        
    boxShadow: darkTheme.shadows[5],                  
};


const BannerHome = (props) => {      
    const [loading, setLoading] = useState(false);
    const [banners, setBanners] = useState(props ? props.data : [])
    useEffect(() => {
        setBanners(props ? props.data : [])
    }, [props]);
    return (
        <Fragment>
            {loading ? (
                <Skeleton variant="rectangular" height={340} sx={{borderRadius: darkTheme.spacing(1) }} /> 
            ):(
            <Typography component="div" sx={sliderContainer}>            
                {banners.length > 0 ? (
                <Swiper
                    modules={[Navigation, Pagination, Autoplay]}
                    spaceBetween={0}
                    slidesPerView={1}
                    navigation  
                    autoplay={true}
                    loop={false} 
                    freemode="true"
                >                        
                    <>
                        {banners.map((event, i) => (
                            <div key={nanoid(30)}> 
                                {event.img_path ? (
                                    <SwiperSlide>
                                        <Link href={event.link}>
                                            <a>
                                                <Typography component="div" sx={slider}>
                                                    <Image 
                                                        src={event.img_path}                                                
                                                        alt=''                                                                                                                                                                     
                                                        priority                                                        
                                                        height={32}
                                                        width={`100%`}                                                        
                                                        layout="responsive"
                                                        objectFit="cover"
                                                        objectPosition="top"
                                                        style={{ borderRadius:  darkTheme.spacing(1)}}
                                                    />
                                                </Typography>
                                            </a>
                                        </Link>                                
                                    </SwiperSlide>
                                ):''}
                            </div>
                        ))}
                    </>                    
                </Swiper>
            ) : ('')}            
            </Typography> 
        )}
        </Fragment>   
    )
}

export default BannerHome
